import React from 'react';
import { Truck, CheckCircle, Clock } from 'lucide-react';
import { format, addBusinessDays } from 'date-fns';

// Next-day dispatch cutoff: 1pm Mon–Thu.
// Orders before cutoff → dispatch today, arrive next working day.
// Orders after cutoff or Fri–Sun → dispatch next working day, arrive the day after.
function arrivesByDate(now = new Date()) {
  const hour = now.getHours();
  const day = now.getDay(); // 0 Sun ... 6 Sat
  const beforeCutoff = hour < 13 && day >= 1 && day <= 4;
  const dispatchDate = beforeCutoff ? now : addBusinessDays(now, 1);
  return addBusinessDays(dispatchDate, 1);
}

export default function DeliveryExpectations({ product }) {
  if (!product) return null;

  const oos = product.in_stock === false || (product.stock_quantity != null && product.stock_quantity <= 0);
  const leadDays = product.lead_time_days != null && product.lead_time_days > 0 ? product.lead_time_days : null;

  if (oos) {
    return (
      <div className="space-y-2.5 mb-6">
        <div className="flex items-center gap-3 text-sm text-white/40">
          <Clock className="w-4 h-4 text-primary" />
          <span>
            Made to Order
            {leadDays
              ? <> — <span className="text-white/70 font-bold">{leadDays}-day lead time</span></>
              : <> — <a href="tel:01515283001" className="text-primary hover:underline font-bold">contact us for lead time</a></>}
          </span>
        </div>
      </div>
    );
  }

  const arrives = arrivesByDate();
  const arrivesLabel = format(arrives, 'EEE d MMM');

  return (
    <div className="space-y-2.5 mb-6">
      <div className="flex items-center gap-3 text-sm text-white/40">
        <Truck className="w-4 h-4 text-primary" />
        <span>
          Next Day Delivery available — order before <span className="text-white/70 font-bold">1pm Mon–Thu</span> · arrives <span className="text-white/70 font-bold">{arrivesLabel}</span>
        </span>
      </div>
      <div className="flex items-center gap-3 text-sm text-white/40">
        <CheckCircle className="w-4 h-4 text-primary" />
        <span>In Stock & Ready to Ship</span>
      </div>
    </div>
  );
}